import React from 'react';
import ComingSoon from '../components/ComingSoon';

const Covisage = () => <ComingSoon title="Covisage" />;

export default Covisage;
